import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
export const HomeStepsIcon = ({ classObject }) => {
    return React.createElement("img", { className: css(styles.container, classObject), src: "/assets/images/icons/home_steps.svg" });
};
const styles = StyleSheet.create({
    container: {
        width: 22,
        height: 22,
    },
});
